<template>
    <div class="p-0 drag-column">
        <div class="pool-card">
            <div class="column-padding">
                <h4 class="card-title mb-3 pb-1 border-bottom">{{ heading }}</h4>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BoardColumn",
        props: {
            heading: {
                type: String,
                default: ''
            },
            empty: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style scoped>
    .column-padding {
        padding: 0 15px;
    }
</style>